import React from 'react';
import SectionBasePage from 'components/SectionBasePage';
import { Tabs } from 'UI';
import { useOrganizationContext } from 'hooks/contextOrganization';

import {
  IncomingTicketsTab,
  ConfirmedTicketsTab,
  ClosedTicketsTab,
} from './Tabs';

enum TabKeys {
  INCOMING = 'INCOMING',
  CONFIRMED = 'CONFIRMED',
  CLOSED = 'CLOSED',
}

const RootPage = (): JSX.Element => {
  const organizationContext = useOrganizationContext();

  return (
    <SectionBasePage
      title="Pedidos de compra"
    >
      <>
        {organizationContext.organization ? (
          <Tabs
            destroyInactiveTabPane
          >
            <Tabs.TabPane tab="Solicitados" key={TabKeys.INCOMING}>
              <IncomingTicketsTab />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Confirmados" key={TabKeys.CONFIRMED}>
              <ConfirmedTicketsTab />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Fechados" key={TabKeys.CLOSED}>
              <ClosedTicketsTab />
            </Tabs.TabPane>
          </Tabs>
        ) : (
          <></>
        )}
      </>
    </SectionBasePage>
  );
};

export default RootPage;
